<script setup lang="ts">
import AppHeader from '@/components/AppHeaderLanding.vue';
import AppShell from '@/components/AppShell.vue';

defineProps<{
    canRegister: boolean;
}>();
</script>

<template>
    <AppShell variant="header">
        <AppHeader :canRegister="canRegister" />
        <main class="flex-1">
            <slot />
        </main>
    </AppShell>
</template>
